import React, { useId } from 'react';
import './InstagramIcon.css';

const InstagramIcon = ({ className = '' }) => {
  const gradientId = `instagram-gradient-${useId().replace(/:/g, '')}`;

  return (
    <svg
      className={`instagram-icon ${className}`.trim()}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="100%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#feda75" />
          <stop offset="25%" stopColor="#fa7e1e" />
          <stop offset="50%" stopColor="#d62976" />
          <stop offset="75%" stopColor="#962fbf" />
          <stop offset="100%" stopColor="#4f5bd5" />
        </linearGradient>
      </defs>
      <rect width="24" height="24" rx="6" fill={`url(#${gradientId})`} />
      <path
        fill="#fff"
        d="M12 7.2a4.8 4.8 0 1 0 0 9.6 4.8 4.8 0 0 0 0-9.6zm0 7.9a3.1 3.1 0 1 1 0-6.2 3.1 3.1 0 0 1 0 6.2zm5.95-8.05a1.12 1.12 0 1 1-2.24 0 1.12 1.12 0 0 1 2.24 0zM17.2 6.4H6.8A2.4 2.4 0 0 0 4.4 8.8v6.4a2.4 2.4 0 0 0 2.4 2.4h10.4a2.4 2.4 0 0 0 2.4-2.4V8.8a2.4 2.4 0 0 0-2.4-2.4zm.8 8.8a.8.8 0 0 1-.8.8H6.8a.8.8 0 0 1-.8-.8V8.8a.8.8 0 0 1 .8-.8h10.4a.8.8 0 0 1 .8.8v6.4z"
      />
    </svg>
  );
};

export default InstagramIcon;
